/* fy-zoom-gallery — abre a galeria do hero em tela cheia.

   Reaproveita a pilha de zoom do próprio tema (a mesma da página de produto
   antiga): window.theme.LoadPhotoswipe (assets/load-photoswipe.js), que
   carrega o PhotoSwipe sob demanda, e o root .pswp que o theme.liquid já
   renderiza em todas as páginas. pinch-zoom e duplo toque
   no mobile, clique para ampliar no desktop, swipe/setas/teclado entre as
   imagens, miniaturas, contador, Esc e botão de fechar.

   Uso:
   <fy-zoom-gallery>
     … <button data-fy-zoom data-image-src data-image-width data-image-height><img></button> …
     <template data-fy-pswp-thumbs>…miniaturas (.pswp__thumb)…</template>
   </fy-zoom-gallery> */
(() => {
  if (customElements.get('fy-zoom-gallery')) return;

  class FyZoomGallery extends HTMLElement {
    connectedCallback() {
      this.triggers = Array.from(this.querySelectorAll('[data-fy-zoom]'));
      this.thumbsTemplate = this.querySelector('[data-fy-pswp-thumbs]');
      this.triggers.forEach((trigger, index) => {
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          this.open(index, trigger);
        });
      });
    }

    open(index, trigger) {
      if (!window.theme || !window.theme.LoadPhotoswipe) {
        console.warn('fy-zoom-gallery: loader do PhotoSwipe do tema indisponível');
        return;
      }

      const items = this.triggers.map((el) => {
        const img = el.querySelector('img');
        return {
          src: el.dataset.imageSrc,
          w: parseInt(el.dataset.imageWidth, 10),
          h: parseInt(el.dataset.imageHeight, 10),
          /* a imagem já exibida serve de placeholder na animação de abertura */
          msrc: (img && img.currentSrc) || el.dataset.imageSrc
        };
      });

      /* mesmas opções da galeria antiga do tema (zoom.js), sem legenda.
         O token "fy-zoom" escopa o CSS da seção (fundo creme, setas) só a
         esta galeria — a página de produto antiga segue com a skin do tema. */
      const options = {
        history: false,
        focus: false,
        index,
        mainClass: `pswp-zoom-gallery fy-zoom${items.length === 1 ? ' pswp-zoom-gallery--single' : ''}`,
        showHideOpacity: true,
        showAnimationDuration: 150,
        hideAnimationDuration: 250,
        closeOnScroll: false,
        closeOnVerticalDrag: false,
        captionEl: false,
        closeEl: true,
        closeElClasses: ['caption-close', 'title'],
        tapToClose: false,
        clickToCloseNonZoomable: false,
        maxSpreadZoom: 2,
        loop: true,
        spacing: 0,
        allowPanToNext: true,
        pinchToClose: false,
        getThumbBoundsFn: () => {
          const rect = trigger.getBoundingClientRect();
          const pageY = window.scrollY || document.documentElement.scrollTop;
          return { x: rect.left, y: rect.top + pageY, w: rect.width };
        }
      };

      /* o tema devolve o foco a este elemento ao fechar */
      if (window.a11y) window.a11y.lastElement = trigger;

      const thumbsContainer = document.querySelector('.pswp__thumbs');
      if (thumbsContainer && this.thumbsTemplate) {
        thumbsContainer.innerHTML = this.thumbsTemplate.innerHTML;
      }

      new window.theme.LoadPhotoswipe(items, options);
    }
  }

  customElements.define('fy-zoom-gallery', FyZoomGallery);
})();
